export default __webpack_public_path__ + "static/media/nectar-cares-logo-blue.068df1c1.png";